module.exports = __webpack_public_path__ + "img/sadnBeauty.b0efee6c.jpg";